export default __webpack_public_path__ + "static/media/300.a731fd41.woff2";